/* eslint-disable import/first */
import React from 'react';
import Box from '@material-ui/core/Box';
import Skeleton from 'react-loading-skeleton';
import css from './index.module.scss';

// TODO: Verify what is the mechanism to show the defaultchecked status of options
// TODO: Verify what decides when to show this component
// TODO: Send this data in cart and order
export default function CartSkelton() {
  return (
    <Box sx={{ padding: '1rem' }}>
      <Skeleton count={1} className={css.Skeleton} height={56} />
      <Box sx={{ padding: '1rem' }}></Box>
      <Skeleton count={4} className={css.Skeleton} height={56} />
      <Box sx={{ padding: '1rem' }}></Box>
      <Skeleton count={3} className={css.Skeleton} height={56} />
      <Box sx={{ padding: '1rem' }}></Box>
      <Skeleton count={4} className={css.Skeleton} height={56} />
    </Box>
  );
}
